module.exports = "/assets/data/45589f1f28bb5c78ded1b6e22828ef01-EX20.data.json";